import * as React from 'react';
import styles from './index.less';

import FTooltip from '@/components/FTooltip';
import { LoadingOutlined } from '@ant-design/icons';
import * as AHooks from 'ahooks';
import fMessage from '@/components/fMessage';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import { history } from '@@/core/history';

interface RecommendThemesProps {
  nodeID: number;

  /** later=显示稍后处理, more=显示浏览更多, force=不显示跳过按钮强制设置主题 */
  btn?: 'later' | 'more' | 'force';

  onSuccess?: () => void;
}

let myInterval: NodeJS.Timeout | null = null;

const THEME_RESOURCE_TYPE_CODE = 'RT001';

let cachedThemeAutoUpdateStatus: 0 | 1 | null = null;

async function fetchThemeAutoUpdateStatus(): Promise<0 | 1> {
  if (cachedThemeAutoUpdateStatus !== null) {
    return cachedThemeAutoUpdateStatus;
  }

  const {
    ret,
    data,
  }: {
    ret: number;
    data?: {
      presentableConfig?: {
        versionShowMode?: number;
      };
    };
  } = await FServiceAPI.Resource.getResourceTypeInfoByCode({
    code: THEME_RESOURCE_TYPE_CODE,
  });
  const versionShowMode = data?.presentableConfig?.versionShowMode;
  const autoUpdateStatus =
    ret === 0 && (versionShowMode === 0 || versionShowMode === 1) ? versionShowMode : 1;
  cachedThemeAutoUpdateStatus = autoUpdateStatus;
  return autoUpdateStatus;
}

function RecommendThemes({ nodeID, btn = 'later', onSuccess }: RecommendThemesProps) {
  const [themeList, setThemeList] = React.useState<any[]>([]);
  const [emptyTheme, setEmptyTheme] = React.useState<any>(null);
  const [$activeId, set$activeId, get$activeId] = FUtil.Hook.useGetState<null | string>(null);
  const [emptyPopupShow, setEmptyPopupShow] = React.useState(false);
  const [successPopupShow, setSuccessPopupShow] = React.useState(false);
  const [countdown, setCountdown] = React.useState(3);

  AHooks.useMount(async () => {
    const [themeList, emptyThemeList] = await Promise.all([
      FServiceAPI.Resource.resourcesRecommend({ recommendType: 1 }),
      FServiceAPI.Resource.resourcesRecommend({ recommendType: 2 }),
    ]);
    setThemeList(themeList.data);
    setEmptyTheme(emptyThemeList.data[0]);
  });

  /** 跳转资源详情页 */
  const toResourceDetail = (id: string) => {
    window.open(FUtil.LinkTo.resourceDetails({ resourceID: id }));
  };

  /** 跳转节点管理页 */
  const toNodeManagement = () => {
    history.push(FUtil.LinkTo.nodeManagement({ nodeID: nodeID, showPage: 'exhibit' }));
  };

  /** 跳转节点-主题管理页 */
  const toNodeThemeManagement = () => {
    myInterval && clearInterval(myInterval);
    history.push(FUtil.LinkTo.nodeManagement({ nodeID: nodeID, showPage: 'theme' }));
  };

  /** 激活主题 */
  async function activeTheme(theme: {
    resourceId: string;
    latestVersion: string;
    resourceName: string;
    resourceTitle: string;
    policies: {
      policyId: string;
      policyName: string;
      status: 0 | 1;
    }[];
  }) {
    if (get$activeId()) {
      return;
    }

    set$activeId(theme.resourceId);

    const autoUpdateStatus = await fetchThemeAutoUpdateStatus();

    const params: Parameters<typeof FServiceAPI.Exhibit.createPresentable>[0] = {
      nodeId: nodeID,
      resourceId: theme.resourceId,
      version: theme.latestVersion,
      batchSignContracts: [
        {
          resourceId: theme.resourceId,
          subjectType: 1,
          policyIds: theme.policies.filter((p) => p.status === 1).map((p) => p.policyId),
        },
      ],
      presentableName: theme.resourceName.split('/')[1],
      policies: [
        {
          policyName: '开放授权',
          policyText: 'for public initial[active]:\n  terminate',
          status: 1,
        },
      ],
      presentableTitle: theme.resourceTitle,
      autoUpdateStatus,
    };
    const {
      ret: ret_createResult,
      errCode: errCode_createResult,
      msg: msg_createResult,
      data: data_createResult,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: { presentableId: string };
    } = await FServiceAPI.Exhibit.createPresentable(params);

    if (ret_createResult !== 0 || errCode_createResult !== 0) {
      self._czc?.push(['_trackEvent', '资源创建页', '激活主题', '', 0]);
      // fMessage('节点创建成功页', 'error');
      fMessage(msg_createResult, 'error');
      set$activeId(null);
      return;
    }

    const activeParams: Parameters<typeof FServiceAPI.Exhibit.presentablesOnlineStatus>[0] = {
      presentableId: data_createResult.presentableId,
      onlineStatus: 1,
    };
    const {
      ret: ret_onlineResult,
      errCode: errCode_onlineResult,
      msg: msg_onlineResult,
      data: data_onlineResult,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: any;
    } = await FServiceAPI.Exhibit.presentablesOnlineStatus(activeParams);

    if (ret_onlineResult !== 0 || errCode_onlineResult !== 0) {
      self._czc?.push(['_trackEvent', '资源创建页', '激活主题', '', 0]);
      fMessage(msg_onlineResult, 'error');
      set$activeId(null);
      return;
    }

    self._czc?.push(['_trackEvent', '资源创建页', '激活主题', '', 1]);

    let time = 3;
    set$activeId(null);
    setEmptyPopupShow(false);
    setSuccessPopupShow(true);
    setCountdown(time);

    myInterval = setInterval(() => {
      setCountdown(--time);
      if (time === 0) {
        myInterval && clearInterval(myInterval);
        history.push(FUtil.LinkTo.nodeManagement({ nodeID: nodeID, showPage: 'theme' }));
      }
    }, 1000);
  }

  /** 激活主题 */
  const activeTheme2 = async (theme: {
    resourceId: string;
    latestVersion: string;
    resourceName: string;
    resourceTitle: string;
    policies: {
      policyId: string;
      policyName: string;
      status: 0 | 1;
    }[];
  }) => {
    if (get$activeId()) {
      return;
    }

    set$activeId(theme.resourceId);

    const autoUpdateStatus = await fetchThemeAutoUpdateStatus();

    const params: Parameters<typeof FServiceAPI.Exhibit.createPresentable>[0] = {
      nodeId: nodeID,
      resourceId: theme.resourceId,
      version: theme.latestVersion,
      batchSignContracts: [
        {
          resourceId: theme.resourceId,
          subjectType: 1,
          policyIds: theme.policies.filter((p) => p.status === 1).map((p) => p.policyId),
        },
      ],
      presentableName: theme.resourceName.split('/')[1],
      policies: [
        {
          policyName: '开放授权',
          policyText: 'for public initial[active]:\n  terminate',
          status: 1,
        },
      ],
      presentableTitle: theme.resourceTitle,
      autoUpdateStatus,
    };
    const {
      ret: ret_createResult,
      errCode: errCode_createResult,
      msg: msg_createResult,
      data: data_createResult,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: { presentableId: string };
    } = await FServiceAPI.Exhibit.createPresentable(params);

    if (ret_createResult !== 0 || errCode_createResult !== 0) {
      self._czc?.push(['_trackEvent', '资源创建页', '激活主题', '', 0]);
      // fMessage('节点创建成功页', 'error');
      fMessage(msg_createResult, 'error');
      set$activeId(null);
      return;
    }

    const activeParams: Parameters<typeof FServiceAPI.Exhibit.presentablesOnlineStatus>[0] = {
      presentableId: data_createResult.presentableId,
      onlineStatus: 1,
    };
    const {
      ret: ret_onlineResult,
      errCode: errCode_onlineResult,
      msg: msg_onlineResult,
      data: data_onlineResult,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: any;
    } = await FServiceAPI.Exhibit.presentablesOnlineStatus(activeParams);

    if (ret_onlineResult !== 0 || errCode_onlineResult !== 0) {
      fMessage('激活失败', 'error');
      set$activeId(null);
      return;
    }

    set$activeId(null);
    setEmptyPopupShow(false);
    fMessage('激活成功', 'success');

    onSuccess?.();
  };

  /** 开关占位主题弹窗 */
  const operateEmptyPopup = () => {
    setEmptyPopupShow(!emptyPopupShow);
  };

  /** 浏览更多主题 */
  const viewMoreTheme = () => {
    history.push(FUtil.LinkTo.market({ query: '主题' }));
  };

  return (
    <>
      <div className={styles.recommendArea}>
        <div className={styles.headerRow}>
          <div className={styles.title}>
            {
              // 设置主题
              FI18n.i18nNext.tAuto('msg_select_starting_theme')
            }
          </div>
          <div className={styles.btns}>
            <div className={styles.developBtn} onClick={operateEmptyPopup}>
              {FI18n.i18nNext.tAuto('btn_active_developer_theme')}
            </div>
            {btn === 'later' && (
              <div className={styles.skipBtn} onClick={toNodeManagement}>
                {FI18n.i18nNext.tAuto('btn_skip_to_node_management')}
              </div>
            )}
            {btn === 'more' && (
              <div className={styles.moreBtn} onClick={viewMoreTheme}>
                浏览更多主题
              </div>
            )}
          </div>
        </div>
        <div className={styles.desc}>
          {FI18n.i18nNext.tAuto('cta_add_theme')}
        </div>
        <div className={styles.list}>
          {themeList.map((item) => {
            return (
              <div className={styles.theme} key={item.resourceId}>
                <div className={styles.cover}>
                  <img className={styles.coverImg} src={item.coverImages[0]} alt={''} />
                  <div className={styles.triangle} />
                  <div className={styles.freeText}>免费</div>
                </div>
                <div className={styles.rightArea}>
                  <div className={styles.titleArea}>
                    <div className={styles.title}>
                      {item.resourceTitle || item.resourceName.split('/')[1]}
                    </div>
                    <FTooltip title='查看资源详情'>
                      <i
                        className={`freelog fl-icon-chakanziyuan ${styles.viewDetail}`}
                        onClick={() => toResourceDetail(item.resourceId)}
                      />
                    </FTooltip>
                  </div>
                  <div className={styles.intro}>{item.intro}</div>
                  <div className={styles.version}>最新版本 {item.latestVersion}</div>
                  <div
                    className={styles.activBtn}
                    onClick={() => {
                      if (btn === 'more') {
                        activeTheme2(item);
                      } else {
                        activeTheme(item);
                      }
                    }}
                  >
                    {$activeId === item.resourceId && (
                      <LoadingOutlined className={styles.loader} />
                    )}
                    {FI18n.i18nNext.tAuto('btn_active_theme')}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {(emptyPopupShow || successPopupShow) && (
        <div className={styles.modal}>
          {emptyPopupShow && (
            <div className={styles.emptyPopup}>
              <div className={styles.title}>
                {FI18n.i18nNext.tAuto('btn_active_developer_theme')}
              </div>
              <div className={styles.desc}>
                {FI18n.i18nNext.tAuto('activethemenow_developer_confirmation_msg')}
              </div>
              <div className={styles.btns}>
                <div className={styles.cancelBtn} onClick={operateEmptyPopup}>
                  {FI18n.i18nNext.tAuto('btn_cancel')}
                </div>
                <div className={styles.activeBtn} onClick={() => activeTheme(emptyTheme)}>
                  {$activeId === emptyTheme.resourceId && (
                    <LoadingOutlined className={styles.loader} />
                  )}
                  {FI18n.i18nNext.tAuto('activethemenow_developer_confirmation_btn')}
                </div>
              </div>
              <i
                className={`freelog fl-icon-guanbi ${styles.closeBtn}`}
                onClick={operateEmptyPopup}
              />
            </div>
          )}

          {successPopupShow && (
            <div className={styles.successPopup}>
              <i className={`freelog fl-icon-a-chenggongzhengqueduigou1 ${styles.successIcon}`} />
              <div className={styles.title}>主题激活成功</div>
              <div className={styles.desc}>
                即将进入节点管理页（{countdown}s）
                <div className={styles.enterBtn} onClick={toNodeThemeManagement}>
                  立即进入
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default RecommendThemes;
